// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  getAuth,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
} from "firebase/auth";
import {
  getFirestore,
  doc,
  setDoc,
  getDoc,
  collection,
  query,
  where,
  onSnapshot,
} from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCATF4JfCHBVII-FxtLQCGxhQGYI-fljjY",
  authDomain: "wordlink-a9084.firebaseapp.com",
  projectId: "wordlink-a9084",
  storageBucket: "wordlink-a9084.appspot.com",
  messagingSenderId: "278100280852",
  appId: "1:278100280852:web:efe71760884dc86a238901",
  measurementId: "G-QL2LTB626C",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
//const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

export {
  auth,
  db,
  signInWithEmailAndPassword,
  doc,
  setDoc,
  getDoc,
  collection,
  onSnapshot,
  query,
  where,
  onAuthStateChanged,
  signOut,
};
